import { SIGNUP_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-bi-hero-background")
  return (
    <Container section>
      <SplitContainer
        className="mt-10 lg:mt-0 lg:py-10 xl:py-20"
        image={illustration}
        imageSize="large"
        imageClassName="scale-150 md:scale-110 lg:scale-110 xl:scale-100 lg:translate-x-[20%] xl:translate-x-[15%] 2xl:translate-x-[20%] mt-[25%] md:mt-[10%] lg:mt-[5%]"
      >
        <Heading
          level="h1"
          title="The open analytics platform that replaces legacy BI"
          subtitle={
            <>
              Preset delivers everything traditional BI tools promise—and more.
              Built on Apache Superset™, get powerful self-serve analytics,
              modern data stack integration, and full customization without
              vendor lock-in.
            </>
          }
          size="huge"
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href={SIGNUP_URL}
          trackClick="Get started now (hero)_Use Cases - BI"
          shadow
        >
          Get started now
        </Button>
      </SplitContainer>
    </Container>
  )
}

export default HeroSection
